import React from 'react';
import ReactModal from 'react-modal';
import styles from './Modal.module.scss';
import cn from "classnames";
import { ReactComponent as CloseIcon } from '../../assets/Imgs/close.svg'
import { PAGES } from "routes/PAGES";
import { useHistory } from "react-router-dom";

ReactModal.setAppElement('#app');

/* docs: http://reactcommunity.org/react-modal/ */
const Modal = ({ children, hasCrossButton, fullScreen, onClose, className, domain, ...props }) => {
    const history = useHistory();
    const customRoutes = [PAGES.WELCOME];
    const isCustom = (domain === 'cpoctoavito' || domain === 'cpocto') && customRoutes.includes(history.location.pathname);
     return (
        <ReactModal
            className={cn(styles.modal, className, { [styles.fullScreen]: fullScreen })}
            overlayClassName={styles.overlay}
            htmlOpenClassName={styles.html}
            onRequestClose={onClose}
            style={{[styles.custom] : isCustom}}
            {...props}
        >
            <div data-community={domain}>
                <div className={styles.modalContent}>
                    {hasCrossButton && <div onClick={onClose} className={styles.crossButton}><CloseIcon /></div>}
                    {children}
                </div>
            </div>
        </ReactModal>
    );
};

export default Modal;
